import { FileText } from "lucide-react";
import { INVOICE_STATUS, fmtEUR, fmtDate } from "./shared";

export function InvoiceCell({ invoice, onClick, testid }) {
  if (!invoice) {
    return <span className="text-xs text-muted-foreground">–</span>;
  }
  const st = INVOICE_STATUS[invoice.status] || INVOICE_STATUS.offen;
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className="text-left rounded-md px-2 py-1.5 -mx-2 hover:bg-secondary transition-colors w-full">
      <div className="flex items-center gap-1.5">
        <span className={`text-[10px] font-semibold uppercase tracking-wider rounded px-1.5 py-0.5 ${st.cls}`}>{st.label}</span>
        {invoice.file && <FileText className="h-3.5 w-3.5 text-primary" aria-label="PDF vorhanden" />}
      </div>
      <div className="text-xs mt-1 tabular-nums">{invoice.betrag != null ? fmtEUR(invoice.betrag) : <span className="text-muted-foreground">kein Betrag</span>}</div>
      {(invoice.rechnungsnummer || invoice.rechnungsdatum) && (
        <div className="text-[10px] text-muted-foreground truncate">
          {invoice.rechnungsnummer || ""}{invoice.rechnungsnummer && invoice.rechnungsdatum ? " · " : ""}{invoice.rechnungsdatum ? fmtDate(invoice.rechnungsdatum) : ""}
        </div>
      )}
    </button>
  );
}
